import { groupBy as _groupBy } from "lodash/fp";
/**
 * Groups list of objects by date Creates object from array where keys are mindights in unix timestamp
 */
const groupByDay = (list, dateKey) => _groupBy((item) => new Date(item[dateKey].valueOf()).setHours(0, 0, 0, 0), list);
export default groupByDay;
